import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Dialog from '../../../dialogModal/dialogModal';
import EmptyPage from '../../../empty-page/emptyPage';
import { standardDate } from '../../../../utils/formatDate';
import DetailsTable from '../../../../pages/orgBilling/detailsTable';
import { fetchActPayoutsCount, fetchActPayoutsData, fetchMoreDetails } from './orgActPayoutFn/orgActPayoutFn';
import Pagination from '../../../pagination/Pagination';

const ActivityPayouts = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [payoutData, setPayoutData] = useState([]);
    const [viewDetailsModal, setViewDetailsModal] = useState(false);
    const [moreDetails, setMoreDetails] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const tableHeader = ['From Date', 'To Date', 'No. of Bookings', 'Total Amount', 'Payout Date', 'Action'];

    const pageNumber = Number(searchParams.get('page')) || 1;
    const limit = 10;
    const offSet = (pageNumber - 1) * limit;
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        fetchActPayoutsData(limit, offSet, setPayoutData, setLoading);
    }, [limit, offSet]);

    useEffect(() => {
        fetchActPayoutsCount(setTotalCount, setLoading);
    }, []);

    const handleViewDetails = async (id) => {
        await fetchMoreDetails(id, setMoreDetails, setLoading);
        setViewDetailsModal(true);
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='billingContainer table-top-container'>
                {/* <div className='alignCenter filter'>
                    <input
                        placeholder='Search...'
                        name='orgSearch'
                        value={searchText}
                        className='orgBillSearch'
                        onChange={(sea) => handleTextChange(sea, setSearchText)}
                    />
                </div> */}
                {payoutData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {payoutData?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td>{row.fromDate ? standardDate(row.fromDate.split('T')[0]) : 'N/A'}</td>
                                            <td>{standardDate(row.toDate.split('T')[0]) ?? 'N/A'}</td>
                                            <td>{row?.actIds?.length ?? 'N/A'}</td>
                                            <td>₹ {row?.totalAmount ?? '0'}</td>
                                            <td>{standardDate(row?.payoutDate?.split('T')[0]) ?? 'N/A'}</td>
                                            <td>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() => {
                                                        handleViewDetails(row._id);
                                                    }}
                                                >
                                                    View Details
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {payoutData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong>{' '}
                                            {row.fromDate ? standardDate(row?.fromDate?.split('T')[0]) : 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[1]}:</strong>{' '}
                                            {standardDate(row?.toDate?.split('T')[0]) ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {row?.actIds?.length ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> ₹ {row?.totalAmount ?? '0'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong>{' '}
                                            {standardDate(row?.payoutDate?.split('T')[0]) ?? 'N/A'}
                                        </p>
                                        <div className='sendMessageBtn'>
                                            <button
                                                className='actBtn payoutBtn noWidth'
                                                onClick={() => {
                                                    setViewDetailsModal(true);
                                                    handleViewDetails(row._id);
                                                }}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {viewDetailsModal && (
                    <Dialog openModal={viewDetailsModal} heading={'Details'} className='detailsDialog'>
                        <div className='moreDialogContent'>
                            {moreDetails?.length === 0 && !loading ? (
                                <EmptyPage />
                            ) : (
                                <DetailsTable moreDetails={moreDetails} serviceType={'act'} />
                            )}
                            <div className='moreDetailsBtn'>
                                <button className='dialogActBtn cancel' onClick={() => setViewDetailsModal(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
};

export default ActivityPayouts;
